function capitalizeWord(word: string): string {
  return word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word
}

export function getFirstAndSecondName(fullName: string): string {
  if (!fullName) return ''

  const parts = fullName.trim().split(/\s+/)

  if (parts.length === 0) return ''
  if (parts.length === 1) return capitalizeWord(parts[0])

  return `${capitalizeWord(parts[0])} ${capitalizeWord(parts[1])}`
}
